// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "view-static/js/" + chunkId + "." + {"10":"e69da311","52":"5ba41c46","94":"9fb5d548"}[chunkId] + ".js";
};